import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const AuditLogs = () => {
    return <AdminModulePage moduleKey="audit-logs" />;
};

export default AuditLogs;
